applicationOverview.classy.controller({
    name: 'CalculatedAwardController',
    inject: ['$scope', 'SchoolModelService', 'AppModelService', 'ApplicationService', 'AccountModelService', 'BinFactory',
        'BudgetsModelService', 'ApplicationSideBarService', 'DetermineAwardService'],
    init: function()
    {
        
        this.$.schoolinfo = this.SchoolModelService.get()[0];

    }
});